module.exports = __webpack_public_path__ + "img/vmp_ch_master_necromancer_helman_0.e15a20ec.png";